<template>
  <ActivityStatic :src="bg" />
</template>
<script>
import bg from './images/bg.png';
import ActivityStatic from '@/components/Activity-static';
export default {
  name: 'Constellation',
  components: {
    ActivityStatic
  },
  data() {
    return {
      bg
    };
  }
};
</script>
<style lang="scss" scoped></style>
